export { Textarea } from './Textarea'



// WEBPACK FOOTER //
// ./src/views/components/Textarea/index.tsx